import React, { useEffect, useState } from "react";
import Accordion from "../../components/form/Accordion/accordion";
import "./faq.css";
import { useNavigate } from "react-router-dom";
import back from "../../assets/back.svg";
import { useDispatch } from "react-redux";
import { faqList } from "../../redux/actions/faqAction";
import LoadingSpinnerTable from "../../components/utilites/loader";

const FAQ = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    dispatch(faqList(onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    setFaqData(data.data.data.faqs);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  return (
    <>
      <>
        <div
          className="d-flex align-items-center p-2 mx-5 my-2 m-1 mb-2 cursor_pointer"
          onClick={() => navigate(-1)}
        >
          <img src={back} alt="back_btn" />
          <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
            BACK
          </span>
        </div>
        <div style={{ position: "relative" }}>
          {loading == true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable />
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-center align-items-center fn_Nunito my-2">
                <div className=" col-12 mx-auto   ">
                  <div className="text-center">
                    <div>
                      <span className="fs_32 fs_sm_25 fw_500">
                        Frequently Asked Questions
                      </span>
                    </div>
                    <span className="color_747f9e fs_14 fs_sm_12">
                      Have any questions? We’re here to help you
                    </span>
                  </div>
                  <div className="  d-flex justify-content-center mx-auto">
                    <div className="accordion faq-container scrollbar_hidden mx-4">
                      {faqData.length > 0 &&
                        faqData.map((eachRow, index) => (
                          <Accordion
                            key={eachRow.id}
                            data={eachRow}
                            index={index + 1}
                          />
                        ))}
                    </div>
                  </div>
                  <div className="text-center mt-4 faq-support-container">
                    <div>
                      <span className="fs_22 fs_sm_18  fw_700 mt-4 ">
                        Still have questions?
                      </span>
                    </div>
                    <span className="fs_sm_12 color_747f9e fs_14 ">
                      Have any questions? We’re here to help you
                    </span>
                    <div className="mt-3">
                      <button
                        className="support-btn py-2 px-4 text-white fs_12"
                        onClick={() => navigate("/support")}
                      >
                        <span className="my-1">support</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    </>
  );
};

export default FAQ;
